import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartOptions,
  ChartData,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

interface SurveyLineChartProps {
  data: ChartData<"line">;
  options: ChartOptions<"line">;
}

const SurveyLineChart: React.FC<SurveyLineChartProps> = ({ data, options }) => {
  return (
    <Line
      data={data}
      options={options}
      // style={{ width: "990px", height: "497px" }}
      className="survey-line-chart-style"
      style={{ width: "920px", height: "497px" }}
    />
  );
};

export default SurveyLineChart;
